import React from "react";
import { useState, useCallback } from "react";
import { SecondaryButton } from "@graffer-inc/console-design-kit";

import { ApplicationEntity } from "../../../../../application/domain/application/application-entity";
import { ProcedureEntity } from "../../../../../application/domain/procedures/procedure-entity";
import { useModal } from "../../../../../utils/custom-hooks";
import { BaseModal } from "../../../../atoms/base-modal";

// https://bulma.io/documentation/form/radio/
// > Make sure the linked radio buttons have the same value for their name HTML attribute.
const radioNameProp = "outputPDF_contentSelectRadio";

type Props = {
  procedure: ProcedureEntity;
  application: ApplicationEntity;
  outputPDF: () => void;
  outputPDFForCustomer: () => void;
  isPDFOutputting: boolean;
};

export const OutputPDF: React.FC<Props> = ({
  procedure,
  outputPDF,
  outputPDFForCustomer,
  isPDFOutputting,
}) => {
  const outputPDFModal = useModal();
  const [outputContent, setOutputContent] = useState<"forOps" | "forCustomer">(
    "forOps",
  );
  const handleOutputOnModal = useCallback(() => {
    if (outputContent === "forOps") {
      outputPDF();
    } else {
      outputPDFForCustomer();
    }

    // initialize
    setOutputContent("forOps");
    outputPDFModal.close();
  }, [outputContent, outputPDFModal, outputPDF, outputPDFForCustomer]);

  if (procedure.hasCustomerDlPdfMapping()) {
    return (
      <>
        <SecondaryButton
          text={"PDF出力"}
          onClick={outputPDFModal.open}
          disabled={isPDFOutputting}
          data-for-rpa-id={"output-pdf"}
        />
        <BaseModal
          title="出力内容を選択"
          isActive={outputPDFModal.isActive}
          onClose={outputPDFModal.close}
        >
          <section className="modal-card-body">
            <p>出力可能な内容が複数あります</p>
            <div className="control mt-5">
              <label className="radio is-block ml-0">
                <input
                  type="radio"
                  name={radioNameProp}
                  checked={outputContent === "forOps"}
                  onChange={({ target: { checked } }) => {
                    if (checked) {
                      setOutputContent("forOps");
                    }
                  }}
                  className="mr-2"
                />
                職員向けの内容
              </label>
              <label className="radio is-block ml-0 mt-3">
                <input
                  type="radio"
                  name={radioNameProp}
                  checked={outputContent === "forCustomer"}
                  onChange={({ target: { checked } }) => {
                    if (checked) {
                      setOutputContent("forCustomer");
                    }
                  }}
                  className="mr-2"
                />
                申請者向けの内容
              </label>
              <p className="help has-text-weight-normal">
                {
                  "申請完了画面や申請詳細画面から申請者が入手できる内容を出力できます。"
                }
                <br />
                {
                  "内部管理のための「職権訂正」で変更した内容は反映されません（「申請者確認済み訂正」で行った変更は反映されます）。"
                }
              </p>
            </div>
          </section>
          <section className="modal-card-foot">
            <button
              type="button"
              className="button is-fullwidth is-info"
              onClick={handleOutputOnModal}
            >
              この内容を出力する
            </button>
          </section>
        </BaseModal>
      </>
    );
  }

  return (
    <SecondaryButton
      text={"PDF出力"}
      data-for-rpa-id={"output-pdf"}
      onClick={outputPDF}
      disabled={isPDFOutputting}
    />
  );
};
